type EventCallback<T> = (data: T) => void;

interface EventBus {
  on<T>(event: string, callback: EventCallback<T>): void;
  dispatch<T>(event: string, data: T): void;
  remove<T>(event: string, callback?: EventCallback<T>): void;
}

const eventBus: EventBus = {
  on<T>(event: string, callback: EventCallback<T>): void {
    const wrappedCallback = (e: CustomEvent<T>) => callback(e.detail);
    document.addEventListener(event, wrappedCallback as EventListener);
  },
  dispatch<T>(event: string, data: T): void {
    document.dispatchEvent(new CustomEvent<T>(event, { detail: data }));
  },
  remove<T>(event: string, callback?: EventCallback<T>): void {
    if (callback) {
      const wrappedCallback = (e: CustomEvent<T>) => callback(e.detail);
      document.removeEventListener(event, wrappedCallback as EventListener);
    } else {
      console.warn(`Cannot remove all listeners for event: ${event}`);
    }
  },
};

export default eventBus;
